import { createStyles, makeStyles } from '@material-ui/core/styles';
export const useStyles = makeStyles(theme =>
  createStyles({
    root: {
      display: 'flex',
      minHeight: '100vh',
      flexDirection: 'column',
      justifyContent: 'space-between',
    },
    appBar: {
      backgroundColor: theme.palette.common.gray100,
      color: theme.palette.text.primary,
      borderBottom: '3px solid',
      borderBottomColor: theme.palette.primary.main,
      '& svg': {
        color: theme.palette.common.black,
      },
    },
    form: {
      marginBottom: `${theme.spacing(2)}px`,
      padding: theme.spacing(2),
    },
    toolbar: theme.mixins.toolbar,
    content: {
      display: 'flex',
      flexDirection: 'column',
      margin: '0 auto',
      maxWidth: 680,
    },
    logo: {
      margin: 'auto',
    },
    languageSelector: {
      minWidth: 36,
    },
  }),
);
